export enum SearchModeEnum {
  REGULAR = 'REGULAR',
  AUTO = 'AUTO',
}
